/** Paese implicito dell'anagrafica italiana. */
export const ITALY_COUNTRY_CODE = 'IT';
/**
 * Codice Paese nella forma canonica (`IT`, `DE`): il valore arriva come l'ha
 * salvato chi l'ha scritto («it», « It »). Vuoto o assente → `null`.
 */
export function toCanonicalCountryCode(country) {
    return country?.trim().toUpperCase() || null;
}
/**
 * Codice Paese canonico con l'Italia come default: nell'anagrafica un soggetto
 * senza Paese vale italiano.
 */
export function toCountryCodeOrItaly(country) {
    return toCanonicalCountryCode(country) ?? ITALY_COUNTRY_CODE;
}
/**
 * Vero solo per un Paese esplicitamente italiano: un Paese assente NON è
 * l'Italia — il default, dove serve, lo applica chi chiama.
 */
export function isItalianCountryCode(country) {
    return toCanonicalCountryCode(country) === ITALY_COUNTRY_CODE;
}
//# sourceMappingURL=country-code.js.map